module.exports = __webpack_public_path__ + "img/hero_section_image.6cc46d6a.png";